import TrendsReportDetail from './TrendsReportDetail.container';

export default TrendsReportDetail;
